import {
  Box,
  Button,
  Checkbox,
  Flex,
  HStack,
  IconButton,
  Image,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useCallback, useRef, useState } from "react";
import { RiDeleteBin4Line } from "@remixicon/react";
import { Content } from "@/types/content";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";
import Client4 from "@/services/api/client4";
import { contentRemove } from "@/reducer/contentSlice";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import { useCollectContentMutation } from "@/services/api/endpoints/content";

type Props = {
  content: Content;
  index: number;
  onClose: () => void;
  onDelete: (contentId: string) => void;
  handleCheckBox: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void;
};

const SmrHistoryModalItem = (props: Props) => {
  const dispatch = useAppDispatch();
  const { content, index, handleCheckBox, onClose, onDelete } = props;
  const [hovered, setHovered] = useState(false);
  const [currentContentId, setCurrentContentId] = useState("");

  const DialogControl = useDisclosure();

  const user = useSelector(selectUser);
  const userId = user.id;
  const toast = useToast();
  const currentImage = useAppSelector(selectCurrentImage);

  const type =
    content.type === "TextToImage"
      ? "生图"
      : content.type === "Outpaint"
      ? "扩图"
      : content.type === "SmrToImage"
      ? "毛坯房出图"
      : content.type === "Upload"
      ? "上传"
      : "";

  

  return (
    <Box
      background={
        currentImage.id === content.id
          ? "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
          : "#6C7596"
      }
      // background={ "#6C7596"}
      borderRadius="10px"
      p={currentImage.id === content.id ? "3px" : "1px"}
      mb="10px"
      overflow={"hidden"}
      // onClick={handleClickImage}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box
        h="106px"
        overflow={"hidden"}
        borderRadius="10px"
        bg="#161922"
        position={"relative"}
      >
        <Image
          w="100%"
          h="106px"
          objectFit={"cover"}
          cursor="pointer"
          src={content.thumbnail_url}
        />
        {type && (
          <Box
            position={"absolute"}
            top="5px"
            right={"5px"}
            h="22px"
            pl="4px"
            pr="4px"
            borderRadius={"4px"}
            bg="#1E253F"
            fontSize={"12px"}
            color="#FFFFFF"
            textAlign={"center"}
            lineHeight="22px"
          >
            {type}
          </Box>
        )}

        <Checkbox
          position={"absolute"}
          top="5px"
          left={"5px"}
          isChecked={content.isChecked}
          onChange={(e) => handleCheckBox(e, content.id)}
        ></Checkbox>
        <Box
          position={"absolute"}
          bottom="5px"
          right={"5px"}
          bg="#1E253F"
          borderRadius={"4px"}
        >
          <Tooltip label="删除" placement="top">
            <IconButton
              aria-label="delete img"
              size="xs"
              variant="unstyle"
              color="white"
              icon={<RiDeleteBin4Line size={16} />}
              _hover={{ color: "#8E94A9" }}
              onClick={() => onDelete(content.id)}
            />
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrHistoryModalItem;
